import { ElementData } from "../Data/ElementData";
import { ParallaxLayer } from "../GameObjects/ParallaxLayer";
import { WorldElement } from "../GameObjects/WorldElement";

export class Ground extends ParallaxLayer {
    private _flipToggle: boolean;

    constructor(pSpeed: number, pSpawnableElements: ElementData[]) {
        super(pSpeed, pSpawnableElements, new PIXI.Point(0, 0), new PIXI.Point(0, 0), new PIXI.Point(1, 1));
        this._flipToggle = false;
    }

    protected spawnNewElement(): void {
        super.spawnNewElement();
        this.rightElement.flipped = this._flipToggle;
        this._flipToggle = !this._flipToggle;
    }
}
